import React from "react";
import { Box, Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";
import {readableDate} from "../../utils";

export default function RentalContractHistory({vehicle}){

    const getTotalCharge = (rental) => {
        if(rental.rental_type === "LT"){

        }
    }

    return (
        <Box>
            <details>
                <summary><Title>Rental Contracts</Title></summary>
            <Columns isMultiline>
                <Column>
                    <Table isBordered>
                        <thead>
                            <tr>
                                <th>Rental ID</th>
                                <th>Rental Type</th>
                                <th>On Hire Date</th>
                                <th>Chargeable Date</th>
                                <th>Off Hire Date</th>
                                <th>Total Charge</th>
                            </tr>
                        </thead>
                        <tbody>
                        {vehicle.rentals && vehicle.rentals.map(rental => (
                            <tr>
                                <td className={"on-hover-highlight clickable"} onClick={() => window.open(`/editrental/${rental.id}`, "_self")}>{rental.id}</td>
                                <td>{rental.rental_type}</td>
                                <td>{readableDate(rental.on_hire_date)}</td>
                                <td>{readableDate(rental.chargeable_date)}</td>
                                <td>{readableDate(rental.off_hire_date)}</td>
                                <td>{rental.total_worth}</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </Column>
            </Columns>
            </details>
        </Box>
    );
}